import React from "react";
import { Button } from "react-bootstrap";
import { ApproveIcon, ExcelIcon } from "../gui_components/Icons.js";
export class DepositToolBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowApproveButton: this.props.isShowApproveButton,
      isShowExcelButton: this.props.isShowExcelButton,
    };
  }
  approveDeposit = (e) => {
    if (e.detail === 1) this.props.approveDeposit();
  };
  generateExcel = (e) => {
    if (e.detail === 1) this.props.generateExcel();
  };
  render() {
    return (
      <>
        {this.props.isShowApproveButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.approveDeposit(e)}
          >
            <ApproveIcon />
            Approve
          </Button>
        )}
        {this.props.isShowExcelButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.generateExcel(e)}
          >
            <ExcelIcon />
            EXCEL
          </Button>
        )}
      </>
    );
  }
}
